export enum InterfaceStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
